import styled from '@emotion/styled';

export const QrcodeAllowText = styled.p<{ checked: boolean }>`
  display: flex;
  gap: 12px;
  color: ${(props) => (props.checked ? props.theme.color[2] : props.theme.color[6])};
  ${({ theme }) => theme.typography.MEDIUM_16};
  user-select: none;
  cursor: pointer;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
  width: 100%;
  max-width: 600px;
`;

export const DeveloperModeToggle = styled.p<{ checked: boolean }>`
  display: flex;
  color: ${(props) => (props.checked ? '#FF6B35' : props.theme.color[6])};
  ${({ theme }) => theme.typography.MEDIUM_16};
  user-select: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  background-color: ${(props) => (props.checked ? 'rgba(255, 107, 53, 0.1)' : 'transparent')};
  border: 1px solid ${(props) => (props.checked ? '#FF6B35' : 'transparent')};
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background-color: ${(props) =>
      props.checked ? 'rgba(255, 107, 53, 0.15)' : 'rgba(0, 0, 0, 0.05)'};
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: 1280px;
  max-height: 773px;
`;

export const CounterBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 14px;
`;

export const SelectedThemeBox = styled.div`
  width: 600px;
  height: 192px;
  background-color: ${({ theme }) => theme.color[7]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  padding: 8px;

  > p {
    ${({ theme }) => theme.typography.BOLD_36};
    color: ${({ theme }) => theme.color[5]};
  }

  > div {
    display: flex;
    align-items: center;
    gap: 80px;
  }

  > div > img {
    width: 200px;
    height: 132px;
    object-fit: contain;
  }

  > div > button {
    width: 128px;
    height: 72px;
    ${({ theme }) => theme.typography.REGULAR_24};
    background-color: ${({ theme }) => theme.color[3]};
    border-radius: 12px;
    color: ${({ theme }) => theme.color[5]};
  }
`;

export const Description = styled.div`
  > p {
    color: ${({ theme }) => theme.color[2]};
    ${({ theme }) => theme.typography.SEMI_BOLD_24};
    text-align: center;

    &:last-child {
      font-size: 16px;
      font-weight: 400;
    }
  }
`;

export const Counter = styled.div`
  display: flex;
  gap: 160px;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 20px;
`;

export const Count = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  color: ${({ theme }) => theme.color[5]};
  background-color: ${({ theme }) => theme.color[7]};
  ${({ theme }) => theme.typography.BOLD_60};
  border-radius: 50%;
  box-shadow: 0px 4px 4px 0px #00000040;
`;

export const CountButton = styled.button`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  ${({ theme }) => theme.typography.BOLD_36};
  color: ${({ theme }) => theme.color[5]};
  background-color: ${({ theme }) => theme.color[3]};
  box-shadow: 0px 4px 4px 0px #00000040;

  ${(props) =>
    props.disabled &&
    `
    cursor: not-allowed;
    opacity: 0.5;
  `}
`;

export const AccountBox = styled.div`
  width: 200px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.color[5]};
  background-color: ${({ theme }) => theme.color[3]};
  ${({ theme }) => theme.typography.SEMI_BOLD_24};
`;
